import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'
import { languageChange, queryAgreements, queryNotice } from 'store/siteConfig'

export default function(route) {
  const MasterCardSession = Loadable({
    loader: () => import('./MasterCardSession'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          channelMasterCardSessionState: state.channelMasterCardSessionState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          languageChange,
          queryAgreements,
          queryNotice,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/masterCardSession`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <MasterCardSession {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
